/**
 * IAM Governance (Delegations + Access Review) - English
 */
export const iamGovernanceEn = {
  delegations: {
    title: 'Permission Delegations',
    subtitle:
      'Temporarily delegate data permissions to colleagues (PTO / travel / hand-off). One level only — no chain delegation.',
    newButton: 'New Delegation',
    tabs: {
      all: 'All',
      sent: 'Sent by Me',
      received: 'Received by Me',
    },
    columns: {
      from: 'From',
      to: 'To',
      resource: 'Resource',
      valid: 'Valid',
      reason: 'Reason',
      status: 'Status',
      actions: 'Actions',
    },
    status: {
      revoked: 'Revoked',
      expired: 'Expired',
      active: 'Active',
    },
    revoke: 'Revoke',
    revokeConfirm:
      'Revoke this delegation? The delegate will lose this permission immediately.',
    revokeFailed: 'Revoke failed: ',
    loading: 'Loading...',
    empty: 'No delegation records',
    loadFailed: 'Failed to load',
    form: {
      title: 'New Permission Delegation',
      toUser: 'Delegate',
      toUserPlaceholder: 'Click "Pick User" on the right',
      pickUser: 'Pick User',
      pickUserTitle: 'Select the Delegate',
      resource: 'Resource (* = all)',
      validFrom: 'Valid From',
      validTo: 'Valid To',
      reason: 'Reason (required)',
      reasonPlaceholder:
        'e.g. PTO 2026-05-01 ~ 2026-05-07, approval delegation',
      cancel: 'Cancel',
      submit: 'Confirm',
      submitting: 'Submitting...',
      requiredAll: 'Please fill in: delegate / valid window / reason',
      createFailed: 'Create failed: ',
    },
  },

  accessReview: {
    title: 'Access Review',
    subtitle:
      'Compliance: user-role bindings must be reviewed every 90 days. Overdue items appear here.',
    threshold: 'Overdue threshold (days):',
    thresholdOptions: {
      d60: '60',
      d90: '90 (default)',
      d120: '120 (alert line)',
    },
    columns: {
      user: 'User',
      role: 'Role',
      organization: 'Organization',
      createdAt: 'Created',
      lastReviewed: 'Last Reviewed',
      actions: 'Actions',
    },
    systemLevel: 'System-level (global)',
    neverReviewed: 'Never reviewed',
    keep: 'Keep',
    revoke: 'Revoke',
    keepDialogTitle: 'Approve — Keep Role',
    keepDialogDesc:
      'This user-role binding will be marked reviewed (lastReviewedAt updated) and removed from the overdue list.',
    revokeDialogTitle: 'Revoke Role',
    revokeDialogDesc:
      'This user-role binding will be deleted; the user loses the role immediately. Please provide a reason.',
    commentRequired: 'Reason (required)',
    commentOptional: 'Comment (optional)',
    keepPlaceholder: 'e.g. routine review, role still valid',
    revokePlaceholder: 'e.g. transferred / project ended / off-boarded',
    revokeReasonRequired: 'Revocation requires a reason',
    cancel: 'Cancel',
    confirm: 'Confirm',
    submitting: 'Submitting...',
    keepFailed: 'Review failed: ',
    revokeFailed: 'Revoke failed: ',
    loading: 'Loading...',
    empty: '🎉 No overdue items',
    loadFailed: 'Failed to load: ',
    unknownError: 'Unknown error',
  },
};
